import React from 'react'
import {
  Col,
  Panel,
  Row,
  Button,
  FormControl,
  Form,
  Glyphicon,
  Grid
} from 'react-bootstrap'
import { isMobile } from 'react-device-detect'

import FrogMakerTemplateKeywordFilter from './FrogMakerTemplateKeywordFilter';
import SiteSearchFilters from './SiteSearchFilters'
import FrogPlayPopover from './FrogPlayPopover'
import YearPopover from './YearPopover'
const basePath = window.basePath || '';

export default class BoostSiteFilterWeb extends React.Component {
  render() {
    return (
      <Grid>
        <nav className="navbar navbar-default">
          {!isMobile && <div className="navbar-left">
            <Button bsStyle="link" href={`${basePath}/`}>
              <img src={`${basePath}/img/logo_full.png`} width="80" height="80" />
              <h3 className='frog-font' style={{ display: 'inline', verticalAlign: 'middle' }}>Boost</h3>
            </Button>
          </div>}
          {!isMobile && this.props.availableKeyword &&
            <FrogMakerTemplateKeywordFilter
              keywordId={this.props.availableKeyword.id}
              isSelected={this.props.selectedKeywordId != null}
              onKeywordClear={this.props.handleKeywordClear}
            >
              FrogMaker Collection
            </FrogMakerTemplateKeywordFilter>
          }
          <div className="navbar-right" style={{ marginRight: '10px' }}>
            <ul className="nav navbar-nav">
              <li className="vcentered-parent">
                <Form inline onSubmit={this.props.handleSearchButton}>
                  <div className="vcentered-child">
                    <Row>
                      <Col md={9} xs={6}>
                        <FormControl
                          type="text"
                          size={40}
                          value={this.props.query}
                          placeholder="Search for a site"
                          onChange={this.props.handleSearchChange}
                        />
                        {this.props.query.length > 1 &&
                          <Glyphicon
                            onClick={this.props.handleSearchClear}
                            className={"input-reset" + (isMobile ? ' input-reset-mobile' : '')}
                            glyph="remove-circle"
                          />
                        }
                      </Col>
                      <Col md={2} xs={2}>
                        <Button
                          type="submit"
                          bsStyle="primary"
                        >
                          Search
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </Form>
              </li>
            </ul>
          </div>
        </nav>
        <Panel style={{ marginBottom: 0 }}>
          <Row>
            <Col md={12}>
              <SiteSearchFilters
                {...this.props.curriculum}
                onFilterChange={this.props.handleFilterChange}
                onFilterClear={this.props.handleFilterClear}
                onCollectionClear={this.props.handleCollectionClear}
                selectedCollection={this.props.selectedCollection}
              />
              {this.props.showFrogPlayPopover &&
                <FrogPlayPopover
                  onClose={this.props.FrogPlayPopoverOnClose}
                />
              }
              {this.props.showYearPopover &&
                <YearPopover
                  year={this.props.curriculum.selectedYear.name}
                  onClose={this.props.YearPopoverOnClose}
                />
              }
            </Col>
          </Row>
        </Panel>
      </Grid>
    );
  }
}